import { ChatChannel, ChatChannelInterface } from "./ChatChannel";

interface ChatChannelGroupInterface extends ChatChannelInterface {
    isAdmin: boolean;
    adminCount: number;
}

export class ChatChannelGroup extends ChatChannel {
    isAdmin: boolean;
    adminCount: number;

    constructor(data: ChatChannelGroupInterface) {
        super(data);
        this.isAdmin = data.isAdmin;
        this.adminCount = data.adminCount;
    }
}